/** Settings → AI usage: this month's tokens, estimated cost and runs. */
export default {
  loadingUsage: "Loading AI usage…",
  usageTotal: "{tokens} tokens across runs started this month.",
  usageUnavailable: "AI usage unavailable.",
  usageCost:
    "About {cost} at API prices. Your AI provider bills this, not Denker.",
  runsThisMonth: "Runs started this month",
  noRuns: "No runs this month.",
  modelNotRecorded: "Model not recorded",
  runTokens: "{input} in · {output} out · {started}",
  showMore: "Show more",
  loadFailed: "Couldn’t load AI usage. Try again.",
  loadMoreFailed: "Couldn’t load more runs. Try again.",
} as const;
